import { FC } from "react";
import type { StepperProps } from "../lib/type";
import { DesktopStepper } from "./DesktopStepper";
import { MobileStepper } from "./MobileStepper";
import { useStore } from "zustand";
import { useShallow } from "zustand/react/shallow";
import {
  TransactionStatusEnum,
  transactionStatusStore,
} from "../../pages/StepPage/components/useBillingPollingSSE";
import { useProcessInstanceStore } from "@/src/stores/useProcessInstanceStore";

const FINISHED_STATUSES = [
  TransactionStatusEnum.SIGNING_IN_PROGRESS,
  TransactionStatusEnum.BILLING_IN_PROGRESS,
  TransactionStatusEnum.CONTRACT_SIGNED,
];

export const Stepper: FC<StepperProps> = (props) => {
  const isCheckStep = useProcessInstanceStore(
    ({ processInstance }) =>
      processInstance?.activeStep?.orderStatus === "CHECK_AND_SIGN",
  );
  const isStepperFinished = useStore(
    transactionStatusStore,
    useShallow(
      ({ transactionStatus }) =>
        transactionStatus !== null &&
        FINISHED_STATUSES.includes(transactionStatus),
    ),
  );

  const activeStep =
    isStepperFinished && isCheckStep ? props.steps.length : props.activeStep;

  return (
    <>
      <DesktopStepper {...props} activeStep={activeStep} />
      <MobileStepper {...props} activeStep={activeStep} />
    </>
  );
};
